module.exports = __webpack_public_path__ + "img/404-page-mobile-back.800f471.png";